var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#0091EA",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 14,
    fill: "url(#pattern0_3902_1786)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3902_1786",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3902_1786",
    transform: "scale(0.015625 0.0192308)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3902_1786",
    width: 64,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA0CAMAAAANBM47AAAAAXNSR0IB2cksfwAAAIpQTFRFAAAALy8vMjIyNDQ0MTEzMDAyMDAyMDAzMDAyMDAzMDAzMTEyLi4uLy8yMDAzMDAyMDAzLy8zMDAzMDAzMDAyLy8yPT09MDAyLy8zf1L4fU/4fVD5Li40fl7/fFH5MTExLy8zelH1fFD5f0//MDAyfVD6MzMze0/3MDAzMTE0fFD4MDAyf0/3fU/5IU37jgAAAC50Uk5TAB83F2eu9v++d46GD1/uzrZ/nsbmbweWPwAAAC8AAEdPAAAApgAnAN5XANYAAPxdnEQAAALhSURBVHiczZfrU9pAEMB3c8QESDDQEXWkVUZK7bT//z/SabWdjo+RjlStYBMeUSHduzwIl4RePnSm+4FJNrlfdvf2cSAUC+Jyw9P4pXw1Q5IQ8rQoD2BGalGgo1cSYKNPvyaZgGKtwUalADX6vD0OQiOsqk+0+kMJQGtCDP02ubfq402EDGDnNxi1IcA+efAjVGmWX0yQAZ1bDNoDeI3cgwgAhxx4qQZwZvzVrghjAoAKA/NRCXB0A8tnOA7E+hUAdsdFJkiA3jXsDODtFCRA/wrMBe4O6JLN1vJTAjR86xe8ixNnBeCuJdLF0yKApkNtBAfxbQpAm8PFehbOWeMkVdcB78+hOTw24nilAJ076H1tUXa0X92QMbY5yAVUl3D4bV/LsQBOVnbzVO8OvDxAcwpPwcdE9yn1qL3KTWCOxzcrA8CDyRSeFXoAoI7xtsaAw/nCFRdbrgKA+xplVgjo3AeJeVMVAHz4Ts4mALFH9qMFM2OOcyUARatxFwMoT6HnXYUG1JRcgL0ROD8jAFVKUE81ACXBrWgfUES0OSy3XBRHdRwCdC0yppRQ2UYukC22VtJ+EPuoifpCisDipfR6XvfocMeR6vRl8+jIk/bcF1/3ALfn3bPsC/1zW9JUjEHqjjVAo2rqfQnw5IJaiCxR9a+L3JiZPaN8JkC2XVKI80SbSQrawH00A/teftMMsjV15Lm9z5KONV0LaRBlKlh0Rlko7r6s07UAydxMARqQU1L0pQyg/gLYXrq8k2cBxprKzwXQHEYecdNYT0VlwPbcRmi3LsAJ1giqLtDMXFI594c+9E7TgVQE9B9caPKGsjelJ071shygf71Ain94kmqlTkGUAcUxoNpNi8Vuo65ccdzygIDNUnOhM/GYuNi92gBgeqJhb854W8495ikn0r8FqCTSfw6QpQxAuR8UAagjNZikm6Cf6UiFADoq5UmmJxYC+PDOSr2SN8AK/rH8bS6s5A946xy8zoklxAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineStorage);
export default __webpack_public_path__ + "static/media/online_storage.6d131603fde1b76721ac2c34f78f066e.svg";
export { ForwardRef as ReactComponent };